var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioIcon = function SvgAudioIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B6790",
    fillRule: "evenodd",
    d: "M40.742 14.696A1.5 1.5 0 0 1 41.5 16v32a1.5 1.5 0 0 1-2.266 1.29L23.588 40H20a5.5 5.5 0 0 1-5.5-5.5v-5A5.5 5.5 0 0 1 20 24h3.588l15.646-9.29a1.5 1.5 0 0 1 1.508-.014m-2.242 3.94L24.766 26.79A1.5 1.5 0 0 1 24 27h-4a2.5 2.5 0 0 0-2.5 2.5v5A2.5 2.5 0 0 0 20 37h4c.27 0 .534.073.766.21L38.5 45.365z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B6790",
    d: "M43.828 25.95a1.5 1.5 0 0 1 2.12-.021A8.48 8.48 0 0 1 48.5 32a8.48 8.48 0 0 1-2.551 6.071 1.5 1.5 0 0 1-2.1-2.142c1.02-1 1.651-2.39 1.651-3.929 0-1.54-.63-2.929-1.65-3.929a1.5 1.5 0 0 1-.022-2.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B6790",
    d: "M49.53 22.438a1.5 1.5 0 0 0-2.118 2.125A10.46 10.46 0 0 1 50.5 32c0 2.906-1.179 5.535-3.088 7.438a1.5 1.5 0 0 0 2.117 2.124A13.46 13.46 0 0 0 53.5 32c0-3.736-1.52-7.12-3.97-9.562"
  })));
};
export default SvgAudioIcon;